import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { User } from '../../interfaces/routering/user';
import { AuditLog } from '../../interfaces/routering/audit-log';

@Injectable()

export class UserService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<User[] | boolean> {
    return new Observable<User[] | boolean>((o: Subscriber<User[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.users.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<User[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<User | boolean> {
    return new Observable<User | boolean>((o: Subscriber<User | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.users.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<User>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('routering.users.create'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('routering.users.update', {':id': id}), formData);
  }

  delete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('routering.users.delete', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  restore(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('routering.users.restore', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  restoreDisabledUser(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('routering.users.restore-disabled-user', {':id': id}))
        .subscribe(
          (response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false)
        );

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  inactiveCount(): Observable<number> {
    return new Observable<number>((o: Subscriber<number>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.users.inactive.count'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<number>response.data);
          } else {
            o.next(0);
          }
        }, (): void => {
          o.next(0);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  inactive(): Observable<User[] | boolean> {
    return new Observable<User[] | boolean>((o: Subscriber<User[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.users.inactive.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<User[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  inactiveDelete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('routering.users.inactive.delete', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  inactiveExport(): Observable<ServerResponse> {
    return this.api.export(this.apiEndpoints.get('routering.users.inactive.export'));
  }

  export(): Observable<ServerResponse> {
    return this.api.export(this.apiEndpoints.get('routering.users.export'));
  }

  auditLogs(): Observable<AuditLog[] | boolean> {
    return new Observable<AuditLog[] | boolean>((o: Subscriber<AuditLog[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.users.audit-logs.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<AuditLog[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
